import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function Register() {
  const [form, setForm] = useState({ email: "", username: "", password: "", confirm_password: "" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) return toast.error("Passwords do not match");
    if (form.password.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created — let's set up your profile");
      navigate(loc.state?.redirect || "/apply/senior-sales-executive-ireland");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Create your candidate profile" subtitle="Join KERA's talent network in a couple of minutes"
      footer={<>Already have an account? <Link className="text-[#8a6a1e] font-medium hover:underline" to="/login">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="email">Email address</Label>
          <Input id="email" data-testid="register-email-input" type="email" required value={form.email} onChange={set("email")} className="mt-1.5 bg-white" />
        </div>
        <div>
          <Label htmlFor="username">Username</Label>
          <Input id="username" data-testid="register-username-input" required value={form.username} onChange={set("username")} className="mt-1.5 bg-white" />
        </div>
        <div>
          <Label htmlFor="password">Password</Label>
          <Input id="password" data-testid="register-password-input" type="password" required value={form.password} onChange={set("password")} className="mt-1.5 bg-white" />
        </div>
        <div>
          <Label htmlFor="confirm">Confirm password</Label>
          <Input id="confirm" data-testid="register-confirm-input" type="password" required value={form.confirm_password} onChange={set("confirm_password")} className="mt-1.5 bg-white" />
        </div>
        <Button data-testid="register-submit-button" disabled={loading} type="submit"
          className="w-full bg-[#C79A3B] hover:bg-[#D4AF57] text-[#101820] font-bold rounded-full h-11">
          {loading ? "Creating account…" : "Create account"}
        </Button>
        <p className="text-xs text-muted-foreground text-center">By continuing you agree to KERA processing your details for recruitment purposes.</p>
      </form>
    </AuthShell>
  );
}
